import styled from 'styled-components';

export const StyledSectionSelectorContainer = styled.div`
    border: 1px solid ${({theme}) => theme.colors.verdigris};
    border-radius: ${({theme}) => theme.radius.m};
`;

export const SectionSelectorTitle = styled.div`
    border-bottom: 1px solid ${({theme}) => theme.colors.verdigrisDark};
    background-color: ${({theme}) => theme.colors.mintCream};
    border-radius: ${({theme}) => theme.radius.m} ${({theme}) => theme.radius.m} 0 0;
    padding-left: ${({theme}) => theme.spacing.m};
    display: flex;
    align-items: center;
    height: ${({theme}) => theme.height.h6};
`;

export const SectionSelectorOptionsContainer = styled.div`
    width: ${({theme}) => theme.width.full};
    height: ${({theme}) => theme.width.full};
    border-radius: 0 ${({theme}) => theme.radius.m};
    padding: 5px 0;
`;
